export default __webpack_public_path__ + "static/media/NeonFood_Coffee_v001.7ed39fae.gif";